import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { StorageFile } from '@lib/models/generated/graphql';
import { DocumentsService, FicheStorageFile } from '@lib/services/documents.service';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';

@Component({
  selector: 'app-allocation-consultant-file-upload',
  templateUrl: './allocation-consultant-file-upload.component.html',
  styleUrls: ['./allocation-consultant-file-upload.component.scss'],
})
export class AllocationConsultantFileUploadComponent {
  isloading: boolean = false;
  toUploadfiles: FicheStorageFile[] | null;
  ficheCurrentFile: StorageFile | null;

  fileControl = new FormControl<File[]>([], { validators: [Validators.required] }); //use only to display required field error
  @Input() set currentFile(value: StorageFile | undefined | null) {
    if (!value) {
      this.fakeCurrentFile = undefined;
      this.ficheCurrentFile = null;
      return;
    }
    this.fakeCurrentFile = new File([], value.fileName, {
      type: value.fileType,
    });
    this.ficheCurrentFile = value;
  }

  fakeCurrentFile: File | undefined; // use for oui-file-item

  constructor(private documentService: DocumentsService, private ficheConseilService: FicheConseilService) {}

  onFileChange(files: File[] | null) {
    this.onUploadFile();
  }

  onUploadFile() {
    this.isloading = true;
    if (this.toUploadfiles) {
      this.documentService
        .uploadFicheStorageFiles(this.toUploadfiles)
        .then((storageFiles: FicheStorageFile[]) => {
          const updatedFile = storageFiles[0].storageFile;
          const updatedType = storageFiles[0].type;
          if (updatedFile && updatedFile.fileName) {
            this.ficheConseilService.onAllocationConsultantFileChanged(
              updatedFile.id,
              updatedFile.fileName,
              updatedType
            );
          }
          this.isloading = false;
          this.toUploadfiles = [];
        })
        .catch(() => {
          this.isloading = false;
          this.toUploadfiles = [];
        });
    }
  }

  async onCurrentFileClick($event: File) {
    await this.documentService.displayStorageFileInNewTab(this.ficheCurrentFile!);
  }
  deleteCurrentFile($event: File) {
    this.fakeCurrentFile = undefined;
    this.ficheConseilService.onAllocationConsultantFileDeleted();
    this.toUploadfiles = [];
  }

  markAsTouched() {
    this.fileControl.markAsTouched();
  }
}
